import { useEffect, useRef } from 'react';
import { formatPrice } from '../../utils/formatPrice';

declare const dataLayer: Record<string, unknown>[];

interface MinOrderAlertProps {
  minOrder: number;
  currentTotal: number;
}

export function MinOrderAlert({ minOrder, currentTotal }: MinOrderAlertProps) {
  const remaining = minOrder - currentTotal;
  const tracked = useRef(false);

  useEffect(() => {
    if (remaining > 0 && !tracked.current) {
      tracked.current = true;
      dataLayer.push({
        event: 'min_order_not_met',
        min_order: minOrder,
        cart_total: currentTotal,
        remaining,
        deficit_percentage: Math.round((remaining / minOrder) * 100),
      });
    }
  }, [remaining, minOrder, currentTotal]);

  if (remaining <= 0) return null;

  return (
    <div className="flex items-center gap-3 py-3 px-4 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 text-sm mb-3">
      <svg className="shrink-0 text-yellow-600" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <span>
        Para realizar tu pedido tenes que llegar al <strong className="font-semibold">minimo de {formatPrice(minOrder)}</strong>
      </span>
    </div>
  );
}
